import React from 'react';
import './AdTypeTile.scss';

export default function AdTypeTile({icon, heading, description, type, onTileSelected}) {
  return (
    <button className="form-tile" onClick={() => onTileSelected(type)}>
      <span className={`form-tile__icon form-tile__icon--${icon}`}></span>
      <h2 className="form-tile__heading">{heading}</h2>
      <p className="form-tile__description">{description}</p>
    </button>
  )
}
